import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, PlusCircle, ListChecks, User, Inbox, Send, ShieldCheck, BarChart3 } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { useLang } from "@/lib/i18n";

function NavItem({ to, icon: Icon, label, testId, active }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className={`flex flex-col items-center justify-center gap-0.5 flex-1 py-1.5 text-[11px] font-medium transition-colors ${
        active ? "text-emerald-600" : "text-zinc-500 hover:text-zinc-900"
      }`}
    >
      <Icon className="h-5 w-5" strokeWidth={2.2} />
      <span>{label}</span>
    </Link>
  );
}

export default function BottomNav() {
  const { user } = useAuth();
  const { t } = useLang();
  const { pathname } = useLocation();
  if (!user) return null;

  let items = [];
  if (user.role === "customer") {
    items = [
      { to: "/customer", icon: Home, label: t("home"), testId: "nav-customer-home" },
      { to: "/customer/new", icon: PlusCircle, label: t("createRequest"), testId: "nav-customer-new" },
      { to: "/customer/requests", icon: ListChecks, label: t("myRequests"), testId: "nav-customer-requests" },
      { to: "/profile", icon: User, label: t("profile"), testId: "nav-customer-profile" },
    ];
  } else if (user.role === "merchant") {
    items = [
      { to: "/merchant", icon: Home, label: t("home"), testId: "nav-merchant-home" },
      { to: "/merchant/feed", icon: Inbox, label: t("feed"), testId: "nav-merchant-feed" },
      { to: "/merchant/offers", icon: Send, label: t("myOffers"), testId: "nav-merchant-offers" },
      { to: "/profile", icon: User, label: t("profile"), testId: "nav-merchant-profile" },
    ];
  } else if (user.role === "admin") {
    items = [
      { to: "/admin", icon: BarChart3, label: t("dashboard"), testId: "nav-admin-dash" },
      { to: "/admin?tab=pending", icon: ShieldCheck, label: t("merchants"), testId: "nav-admin-merchants" },
      { to: "/admin?tab=requests", icon: ListChecks, label: t("requests"), testId: "nav-admin-requests" },
      { to: "/profile", icon: User, label: t("profile"), testId: "nav-admin-profile" },
    ];
  }

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full md:max-w-xl bg-white/90 backdrop-blur-xl border-t border-zinc-200 z-50"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="flex">
        {items.map((it) => (
          <NavItem key={it.to} {...it} active={pathname === it.to || pathname.startsWith(it.to + "/")} />
        ))}
      </div>
    </nav>
  );
}
